import { SF_COVER_CATEGORIES, PAGES } from '@om/redux/actions/sizotsaFuneralCover/types';
import {
    getCoverType,
    getLivesCovered,
    getQuoteForm,
} from '@om/redux/selectors/sizotsaFuneralCover/quote';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { OmButton, OmEfpAddCoverDrawer, OmFormError, OmFormInputFieldWrapper, OmLoader, OmRadioButtonGroup, OmSideDrawer } from '@om/component-library-react';
import { addToQuote, setBenefitsOnPremimumValue, setBenefitsValue, setQuoteDetailsStateValue, setQuoteDetailsValue, setQuoteDrawerValue } from '@om/redux/actions/sizotsaFuneralCover/quote';
import { DEFAULT_VALIDATION_DELAY } from '../../../config';
import { navigateToReplacementPolicy } from '@om/redux/actions/sizotsaFuneralCover/routing';
import { navigate } from 'gatsby';
import axios from "axios"
import { getAgentCodeRequest } from '@om/redux/actions/sizotsaFuneralCover/referenceData';
import { getIsAgentExists } from '@om/redux/selectors/sizotsaFuneralCover/referenceData';


const FormContent = () => {
    const dispatch = useDispatch();
    const { coverType, formFields,livesCovered,isAgentExists} = useSelector(
        createStructuredSelector({
            coverType: getCoverType,
            formFields: getQuoteForm,
            livesCovered:getLivesCovered,
            isAgentExists:getIsAgentExists,
            
        })
    );    
    const { agentDetail,agentCode, currentResidence } = formFields;
    const actionHandler = (fieldType, value, displayValue = null) => {
        dispatch(setQuoteDetailsValue({ fieldType, value, displayValue }));
    };

    useEffect(() => {
        if (!agentCode?.value) return;
        const handler = setTimeout(() => {
            dispatch(getAgentCodeRequest(agentCode?.value));
        }, 800); 

        return () => clearTimeout(handler);
    }, [agentCode?.value]);
    
    return (
        <>
            <OmSideDrawer
                open={coverType === SF_COVER_CATEGORIES.AGENT}
                onOnSideDrawerClosed={() => {
                    dispatch(setQuoteDrawerValue({ fieldType: 'coverType', value: null }));
                }}
            >
                <div slot="side-drawer-content">
                    <OmEfpAddCoverDrawer>
                        <div className="progressive-disclosure-form-wrapper">
                            <h5 className="no-top-margin no-bottom-margin medium">
                                Great. <strong>Are you an agent</strong> applying for a customer?
                            </h5>

                            <span className="mobile-line-break">
                                <br />
                            </span>
                            {/*
                            <p className="inline-group">
                                <strong>
                                    Cash back <br />
                                </strong>
                                <span className="mobile-line-break no-top-margin small">
                                    The Cashback benefit pays out 10% of all premiums paid every 5 years, if there was
                                    no claim paid on the policy.
                                </span>
                            </p> */}
                            <OmRadioButtonGroup
                                vertical="false"
                                groupName="retirement-for"
                                value={agentDetail?.value}
                                onOnSelection={(event) => actionHandler('agentDetail', event.detail)}
                            >
                                <ul>
                                    <li value={'Yes'}>Yes</li>
                                    <li value={'No'}>No</li>
                                </ul>
                            </OmRadioButtonGroup>
                            <div slot="hint-text">
                                <OmFormError message={agentDetail.error} />
                            </div>

                            {agentDetail.value === 'Yes' && (
                                <>
                                    <p className="no-bottom-margin">Alright. Please enter your agent code below.</p>
                                    <OmFormInputFieldWrapper
                                        isSensitive
                                        required
                                        name="agentCode"
                                        size="full"
                                        align="left"
                                        placeholder="Agent code"
                                        validationDelay={DEFAULT_VALIDATION_DELAY}
                                        value={agentCode?.value}
                                        state={!isAgentExists ? 'error' : agentCode?.status}
                                        // errorMessage={agentCode?.error}
                                        // onInputBlur={()=>dispatch(getAgentCodeRequest(agentCode?.value))}
                                        onPersist={(event) => actionHandler('agentCode', event.detail)}
                                    />
                                    {(!isAgentExists && agentCode?.value) && (
                                        <div class="kametlhfuneralaCustom-alert" role="alert">
                                            The agent code you entered is currently inactive. Please reach out to your
                                            support agent for assistance, or contact us at +267 399 5700 or
                                            lifeenquiries@oldmutual.co.bw.
                                        </div>
                                    )}
                                </>
                            )}

                            <h5 className="no-top-margin no-bottom-margin medium">
                                Are you a permanent resident of Eswatini? *
                            </h5>

                            <span className="mobile-line-break">
                                <br />
                            </span>
                            <OmRadioButtonGroup
                                vertical="false"
                                groupName="currentResidence-for"
                                value={currentResidence?.value}
                                onOnSelection={(event) => actionHandler('currentResidence', event.detail)}
                            >
                                <ul>
                                    <li value={'Yes'}>Yes</li>
                                    <li value={'No'}>No</li>
                                </ul>
                            </OmRadioButtonGroup>
                            <div slot="hint-text">
                                <OmFormError message={currentResidence.error} />
                            </div>
                            {   currentResidence.value==='No' && 
                                <strong>You can't apply unless you are a permanent resident of Eswatini.</strong>
                            }

                            <div className="action-buttons">
                                <OmButton
                                    type="text"
                                    size="small"
                                    text="Cancel"
                                    onClick={() =>
                                        dispatch(setQuoteDrawerValue({ fieldType: 'coverType', value: null }))
                                    }
                                />
                                {currentResidence.value === 'Yes' && (
                                    <OmButton
                                        type="primary"
                                        size="small"
                                        text="Continue"
                                        disabled={!isAgentExists && agentDetail?.value === 'Yes'}
                                        onClick={() => {
                                            dispatch(
                                                addToQuote({
                                                    coverType: SF_COVER_CATEGORIES.AGENT,
                                                    relation: 'agent',
                                                })
                                            );
                                            if (Object.keys(livesCovered[SF_COVER_CATEGORIES.AGENT]).length) {
                                                dispatch(navigateToReplacementPolicy());
                                                navigate(PAGES[0].URL);
                                            }
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </OmEfpAddCoverDrawer>
                </div>
            </OmSideDrawer>
        </>
    );
};

// const loadingText = (benefitsDrawer) => {
//     return (
//         <>
//             <BenefitsSideDrawerWrapper
//                 drawerIsOpen={benefitsDrawer}
//                 editCategory={EFP_COVER_CATEGORIES.DIRECT_FAMILY}
//             >
//                 <OmLoader loaderText={'Loading...'} isLoading={true} />
//             </BenefitsSideDrawerWrapper>
//         </>
//     );
// };

const AgentDetailsDrawer = () => {
    // if (applicationReferenceDataValid && quoteReferenceDataValid) {
    return <FormContent />;
    // }

    // return (
    //     <div>
    //         {loadingText(benefitsDrawer)}
    //     </div>
    // );
};

export default AgentDetailsDrawer;
